import { componentName, RecaptchaClass } from './RecaptchaClass';

customElements.define(componentName, RecaptchaClass);

export { RecaptchaClass, componentName };
